export default "/images/vendor/flag-icons/flags/4x3/io.svg?b7a5e36a161893d2378c3fb7918eb3a8";